import without from 'lodash/without';
import isEqual from 'lodash/isEqual';
import { ProductSelectionState } from './state';
import {
    DESELECT_ALL,
    DESELECT_MULTIPLE,
    DESELECT_ONE,
    ProductSelectionAction,
    SELECT_ALL,
    SELECT_MULTIPLE,
    SELECT_ONE,
    SET_SELECTION_MODE
} from './types';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';

const initialState = {
    all: false,
    selected: [],
    excluded: [],
    count: 0,
    selectionMode: false
};

export function productSelectionReducer(
    selectedProducts: ProductSelectionState = initialState,
    action: ProductSelectionAction | LocationChangeAction
): ProductSelectionState {
    let newProps = {} as ProductSelectionState; // FIXME: This let is not that pretty
    switch (action.type) {
        case SELECT_ALL: {
            const count = action.payload;
            return {
                ...selectedProducts,
                selected: [],
                excluded: [],
                all: true,
                count
            };
        }
        case SELECT_ONE: {
            const productId = action.payload.productId;
            if (selectedProducts.all) {
                const foundItem = selectedProducts.excluded.find(item => isEqual(item, productId));
                if (foundItem) {
                    newProps.excluded = without(selectedProducts.excluded, foundItem);
                }
            } else {
                if (!selectedProducts.selected.find(item => isEqual(item, productId))) {
                    newProps.selected = selectedProducts.selected.concat(productId);
                }
            }
            newProps.count = selectedProducts.count + 1;
            return { ...selectedProducts, ...newProps };
        }
        case SELECT_MULTIPLE: {
            const productIds = action.payload.productIds || [];
            return { ...initialState, selected: productIds, count: productIds.length };
        }
        case DESELECT_ALL: {
            return { ...initialState };
        }
        case DESELECT_MULTIPLE: {
            const productIds = action.payload.productIds || [];
            const productsWithoutExcludes = without(selectedProducts.selected, ...productIds);
            return {
                ...selectedProducts,
                ...{ selected: productsWithoutExcludes, count: productsWithoutExcludes.length }
            };
        }
        case DESELECT_ONE: {
            const productId = action.payload.productId;
            if (selectedProducts.all) {
                if (!selectedProducts.excluded.find(item => isEqual(item, productId))) {
                    newProps.excluded = selectedProducts.excluded.concat(productId);
                }
            } else {
                const foundItem = selectedProducts.selected.find(item => isEqual(item, productId));
                if (foundItem) {
                    newProps.selected = without(selectedProducts.selected, foundItem);
                }
            }
            newProps.count = selectedProducts.count - 1;
            if (newProps.count === 0) {
                newProps = initialState;
            }
            return { ...selectedProducts, ...newProps };
        }
        case SET_SELECTION_MODE: {
            const selectionMode = action.payload;
            return { ...selectedProducts, selectionMode: selectionMode };
        }

        case LOCATION_CHANGE: {
            return {
                ...initialState,
                selectionMode: false,
                all: false,
                selected: [],
                excluded: [],
                count: 0
            };
        }
        default:
            return selectedProducts;
    }
}
